module.exports = __webpack_public_path__ + "img/art-23.49b3c74a.png";